export default __webpack_public_path__ + "static/media/icons_warning_gear.eab6c425.svg";